
export default {
  data() {
    return {
      isCalendlyActive: false,
      isDesktop: false,
      argument: {
        titleArgument: `Visez le <span class="font-clash font-bold text-purple-brand">top</span> des recherches Google`,
        surtitle: "Une agence Google Partner proche de vous",
        webArguments: [
          {
            title: "Opportunités",
            text: "Tirez profit de tout le potentiel de la publicité en ligne.",
            img: require("~/assets/img/picto-target.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Savoir-faire",
            text: "Bénéficiez des compétences de nos experts en référencement.",
            img: require("~/assets/img/picto-medal.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Retour sur investissement",
            text: "Générez des résultats rapides à la hauteur de vos ambitions.",
            img: require("~/assets/img/picto-refresh.svg"),
            alt: "Retour sur investissement",
          },
        ],
      },
      arguments2: [
        {
          img: "argument-seo-1.png",
          title: "Plus de trafic de qualité",
          text: "Attirez sur votre site de futurs clients intéressés par votre offre.",
          alt: "Trafic de qualité",
        },
        {
          img: "argument-seo-2.png",
          title: "Plus de contacts",
          text: "Générez un maximum de demandes de devis grâce à la publicité en ligne.",
          alt: "Plus de leads Google Ads",
        },
        {
          img: "argument-seo-3.png",
          title: "Plus de chiffres d'affaires",
          text: "Augmentez vos ventes en étant la première entreprise que vos clients voient sur Google.",
          alt: "Développer son chiffre d'affaires avec Google Ads",
        },
      ],
      reviewCollab: {
        author: "Déborah - Experte en référencement",
        text: "J’aide les pros à développer leur CA en ligne",
        img: "deborah.png",
        alt: "Expert SEA / SEO",
      },

      itemsList: [
        {
          title: "Accompagnement complet avec un expert dédié",
          text: "Pour un suivi sur-mesure et personnalisé dédié à votre activité.",
        },
        {
          title: "Choix des meilleurs mots-clés en fonction de votre activité",
          text: "Pour garantir le meilleur retour sur investissement, nous définissons les mots-clés les mieux adaptés.",
        },
        {
          title: "Création de campagnes et annonces percutantes",
          text: "Pour être dans les meilleurs résultats Google rapidement.",
        },
        {
          title: "Suivi de vos campagnes en temps réel",
          text: "Mesurez l'efficacité de vos campagnes facilement et rapidement avec notre outil de suivi.",
        },
      ],
      price: {
        price: 290,
        text: "",
        engagement: "6 mois d'engagement",
      },

      timeline: {
        surtitle: "Une campagne Google Ads chez aleo :",
        title: `Comment ça <span class="text-primary-500 font-clash font-bold">marche</span>&nbsp;?`,
        steps: [
          {
            img: "seo-step-1.png",
            title: "Étude de votre activité",
            text: "Analyse de vos cibles, de votre zone géographique et de votre entreprise.",
            alt: "Étude d'une stratégie Google Ads",
          },
          {
            img: "seo-step-2.png",
            title: "Préparation de votre page de destination",
            text: "Sur votre site ou créée et optimisée par nos soins et adaptée à votre cible pour générer un maximum de contacts.",
            alt: "Création landing page",
          },
          {
            img: "seo-step-3.png",
            title: "Création de vos campagnes",
            text: "Choix des mots-clés et rédaction d’annonces percutantes pour assurer votre visibilité.",
            alt: "Création de campagne Google Ads",
          },
          {
            img: "seo-step-4.png",
            title: "Gestion et suivi",
            text: "Points téléphoniques avec le référenceur dédié à vos campagnes et analyse de vos rapports statistiques.",
            alt: "Gestion de votre campagne Google Ads",
          },
          {
            img: "seo-step-5.png",
            title: "Étude détaillée des contacts générés par vos campagnes",
            text: "Étude des appels, des formulaires mails et des autres moyens mis en place pour obtenir de nouveaux clients.",
            alt: "Étude et rapport Google Ads",
          },
        ],
      },
      reviews: [
        {
          text: "Merci à l'agence de Nancy et surtout à la conseillère Céline pour son professionnalisme. Ravie d'être accompagnée par ALEO.",
          author: "ESPACE BIEN ETRE 'CHEZ NINA'",
        },
        {
          text: "Tiffany et Kévin ont été fort sympathiques. Je les recommande sans hésitations",
          author: "CUISINES & CONCEPT",
        },
        {
          text: "Réactivité, professionnalisme, merci Tiffany pour le suivi et l'accompagnement !",
          author: "SCHWARTZ ELECTROMENAGER",
        },
        {
          text: "Merci à toute l’équipe pour votre réactivité et votre professionnalisme. Merci à Jamel pour son écoute et son accompagnement au sein de nos projets.",
          author: "ATC HOME",
        },
      ],

      faq: [
        {
          question:
            "Pourquoi devrais-je confier ma campagne Google ads à une agence ?",
          answer: `<p class="pb-4">En qualité<strong> d'agence</strong> web experte en <strong>Google ads</strong> et titulaire de la certification <strong>Google Partners</strong>, nous déployons notre savoir-faire stratégique et opérationnel dans la gestion de vos campagnes ads. </p>
  <p class="pb-4">Notre maîtrise de l'optimisation des <strong>conversions publicitaires</strong> vous assure une visibilité accrue sur les moteurs de recherche grâce à notre expertise en <strong>référencement payant</strong> (SEA). Nous ajustons votre campagne publicitaire selon vos objectifs, maximisons le taux de conversion, optimisons le <strong>coût par clic (CPC)</strong> et nous assurons un suivi rigoureux de vos <strong>KPI</strong> pour une gestion optimale de votre budget.</p>
  <p>En nous confiant votre <strong>campagne Google ads</strong>, vous bénéficiez d'une expertise reconnue et d'un suivi personnalisé par nos <strong>consultants SEA</strong> afin de garantir l’efficacité de vos campagnes publicitaires.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Quelles sont les étapes de la création de ma campagne Google ads avec ALEO ?",
          answer: `<p class="pb-4">Chez ALEO, la mise en place de votre <strong>campagne ads</strong> se fait en trois étapes cruciales. Dans un premier temps, nous nous imprégnons de votre activité, étudions vos points forts et définissons vos <strong>objectifs webmarketing</strong> pour identifier différentes opportunités de croissance sur Google. Selon vos besoins, nous créons une <strong>landing page spécifiquement optimisée</strong> pour votre campagne, conçue pour maximiser le taux de conversion et optimiser le coût par clic (CPC).</p>
  <p class="pb-4">Ensuite, nous sélectionnons les mots-clés les plus pertinents pour votre campagne et déployons une <strong>stratégie ads</strong> robuste en diffusant des annonces textuelles pour afficher votre message publicitaire sur Google. Le tout est géré par nos consultants SEA, assurant le <strong>succès de votre campagne</strong>. Nous veillons à ce que votre campagne soit le reflet fidèle de votre activité pour atteindre vos objectifs. </p>
  <p>ALEO est à votre service pour faire de votre <strong>campagne Google ads</strong> une réussite.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "J'ai déjà un compte Google ads, comment confier mes campagnes SEA à ALEO ?",
          answer: `<p class="pb-4">Si vous avez déjà un compte Google ads et que vous désirez nous confier la gestion de vos <strong>campagnes SEA</strong>, le processus est simple. Plutôt que de reprendre vos campagnes existantes, nous préférons en créer de nouvelles pour repartir sur des bases solides et optimisées.</p>
  <p>En faisant appel à notre <strong>agence certifiée Google Partners</strong>, vous bénéficiez d'une campagne entièrement adaptée à vos besoins et à vos objectifs. Nos consultants SEA vous offrent un <strong>suivi personnalisé</strong>, garantissant la réussite de votre nouvelle campagne.</p>`,
          isCollapsed: false,
        },
        {
          question: "Qu'est-ce qu'une agence certifiée Google Partner ?",
          answer: `<p class="pb-4">Une <strong>agence certifiée Google Partner</strong> est une entreprise reconnue par Google pour son expertise et sa compétence en gestion de <strong>l’outil Google ads</strong>. Cette certification atteste de notre capacité à mener avec efficacité des campagnes publicitaires en ligne, tout en respectant les standards de performance fixés par Google.</p>
  <p class="pb-4">En tant qu'<strong>agence Google Partner</strong>, nous avons accès à des formations avancées et à un support technique dédié, nous permettant de rester à la pointe des dernières tendances en marketing digital.</p>
  <p class="pb-4">Grâce à <strong>Google Analytics et Matomo</strong>, nous suivons le comportement des visiteurs sur votre site internet et optimisons les pages de destination pour améliorer les conversions. Nous utilisons également les données Analytics pour mesurer le <strong>retour sur investissement</strong> (ROI) de votre <strong>campagne de référencement payant</strong>.</p>
  <p>En choisissant notre agence pour votre campagne Google ads, vous faites le choix de l'expertise et de la qualité, pour une <strong>stratégie digitale</strong> performante et adaptée à vos besoins.</p>`,
          isCollapsed: false,
        },
        {
          question: "C’est quoi l’objectif d’une campagne Google Ads ?",
          answer: `<p class="pb-4">L’objectif principal d’une campagne <strong>Google Ads</strong> est d’attirer du <strong>trafic qualifié</strong> sur votre site et de générer des demandes de contact. Une campagne bien optimisée vous permettra de rendre plus visible vos produits ou services aux yeux de vos prospects. En choisissant des <strong>mots-clés pertinents</strong>, vous améliorerez votre <strong>visibilité sur Google</strong> notamment en étant positionné dans les premiers résultats de la SERP.</p><p class="pb-4">Pour avoir les meilleurs résultats possibles, le mieux est de passer par une <strong>agence Google Ads certifiée Google Partner</strong>.</p>`,
          isCollapsed: false,
        },
        {
          question: "Comment fonctionne une agence SEA ?",
          answer: `<p class="pb-4">Une <strong>agence SEA</strong> est une agence spécialisée dans la gestion des campagnes de publicités payantes sur les moteurs de recherche (particulièrement <strong>Google</strong>). Elle analyse vos besoins, définit les objectifs de votre campagne et va concevoir et optimiser des annonces pour qu’elles apparaissent au bon moment, au bon endroit et devant la bonne audience.</p><p class="pb-4">Elle effectuera des ajustements réguliers pour vous garantir les <strong>meilleures performances</strong> en respectant votre <strong>budget</strong>.</p><p class="pb-4">Pour gérer au mieux l’efficacité des campagnes et assurer une meilleure flexibilité, les agences SEA utilisent très souvent le moyen de paiement de leurs clients.</p>`,
          isCollapsed: false,
        },
        {
          question: "Quel budget pour une campagne Google Ads ?",
          answer: `<p class="pb-4">Le <strong>budget d’une campagne Google Ads</strong> varie selon vos objectifs, votre secteur et l’intensité de la concurrence. Votre budget dépendra du <strong>Coût par Clic (CPC)</strong> des mots clés que vous ciblez.</p><p class="pb-4">Pour savoir quels mots-clés cibler et quel budget allouer à votre campagne, le mieux est de faire appel à une <strong>agence Google Ads certifiée Google Partner</strong>.</p>`,
          isCollapsed: false,
        },
        {
          question: "Quels sont les types d’annonces Google Ads ?",
          answer: `<p class="pb-4"><strong>Google Ads</strong> propose de nombreux formats d’annonces, tous adaptés pour des objectifs différents.</p><ul><li><strong>Annonces sur le réseau de recherches</strong> : ces annonces apparaissent directement dans les résultats de recherche Google.</li><li><strong>Annonces display</strong> : Il s’agit d’encarts publicitaires affichés sur certains sites permettant de mettre en avant des visuels.</li><li><strong>Annonces vidéos</strong> : Dans la majorité des cas, il s’agit des publicités sur Youtube.</li><li><strong>Annonces Shopping</strong> : annonces spécifiques aux produits avec des images et des prix.</li></ul><p class="pb-4">Chez ALEO, nous ne proposons que les <strong>annonces sur le réseau de recherches (ou annonces textuelles)</strong> car ce sont celles qui permettent le meilleur retour sur investissement pour la majorité des professionnels.</p>`,
          isCollapsed: false,
        },
        {
          question: "Quel est le prix d’une campagne Google Ads ?",
          answer: `<p class="pb-4">Chez ALEO, nos offres démarrent à partir de <strong>290€ HT/mois</strong> pour la <strong>gestion de vos campagnes Google Ads</strong>. Il vous faudra ajouter le budget publicitaire que vous souhaitez allouer qui sera défini avec votre chargé de référencement Google Ads.</p><p class="pb-4">Il s’agit du fonctionnement permettant le plus de flexibilité dans la gestion et <strong>l’efficacité de vos campagnes Google Ads</strong>.</p>`,
          isCollapsed: false,
        },
        {
          question: "Peut-on choisir sa cible avec une campagne Google Ads ?",
          answer: `<p class="pb-4">Oui, il est possible de choisir sa cible avec précision sur <strong>Google Ads</strong>. Vous pouvez définir différents critères pour atteindre l’audience la plus pertinente pour votre activité comme :</p><ul><li><strong>Les mots-clés</strong> utilisés par les internautes</li><li><strong>Les données démographiques</strong> : âge, sexe, situation géographique</li><li><strong>Centres d’intérêt</strong> ou comportements en ligne</li></ul><p class="pb-4">Ces options permettent d’affiner votre campagne et de toucher les utilisateurs les plus susceptibles d’être intéressés par votre offre.</p><p class="pb-4">Une <strong>agence SEA</strong> pourra ajuster ces paramètres au mieux pour maximiser l’efficacité de votre campagne.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Est-ce que l’agence ALEO peut accompagner des entreprises partout en France ?",
          answer: `<p class="pb-4">Oui, ALEO accompagne des entreprises partout en France et dans les DOM-TOM grâce à un accompagnement 100 % à distance. Que vous soyez en ville ou en province, nous créons des campagnes Google Ads performantes adaptées à votre zone géographique. Nous intervenons dans toutes les régions de France : </p>
  <ul class="pb-4 list-disc list-inside">
    <li><a href="https://www.aleo.agency/agence-google-ads-auvergne-rhone-alpes/" rel="dofollow">Agence Google Ads en Auvergne-Rhône-Alpes</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-bourgogne-franche-comte/" rel="dofollow">Agence Google Ads en Bourgogne-Franche-Comté</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-bretagne/" rel="dofollow">Agence Google Ads en Bretagne</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-centre-val-de-loire/" rel="dofollow">Agence Google Ads dans le Centre-Val de Loire</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-grand-est/" rel="dofollow">Agence Google Ads dans le Grand Est</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-hauts-de-france/" rel="dofollow">Agence Google Ads dans les Hauts-de-France</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-ile-de-france/" rel="dofollow">Agence Google Ads en Île-de-France</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-normandie/" rel="dofollow">Agence Google Ads en Normandie</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-nouvelle-aquitaine/" rel="dofollow">Agence Google Ads en Nouvelle-Aquitaine</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-occitanie/" rel="dofollow">Agence Google Ads en Occitanie</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-pays-de-la-loire/" rel="dofollow">Agence Google Ads en Pays de la Loire</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-provence-alpes-cote-d-azur/" rel="dofollow">Agence Google Ads en Provence-Alpes-Côte d’Azur</a></li>
    <li><a href="https://www.aleo.agency/agence-google-ads-dom-tom/" rel="dofollow">Agence Google Ads dans les DOM-TOM</a></li>
  </ul>
  <p class="pb-4">Nos experts connaissent les particularités de chaque territoire pour créer des campagnes locales pertinentes, ciblées et efficaces, quelle que soit votre localisation.</p>`,
          isCollapsed: false,
        },
      ],
    };
  },
  head() {
    return {
      title: "Agence Google Ads - Agence SEA dès 290 €/mois | ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Boostez votre visibilité en ligne avec ALEO, agence Google Ads experte. Nous créons des campagnes performantes pour maximiser votre retour sur investissement.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads - Agence SEA dès 290 €/mois | ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Boostez votre visibilité en ligne avec ALEO, agence Google Ads experte. Nous créons des campagnes performantes pour maximiser votre retour sur investissement.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-seo.jpg"),
        // },
      ],
    };
  },

  mounted() {
    this.watchMedia();
    this.playVideo();
  },

  methods: {
    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);

      if (this.isDesktop) {
        this.$refs.video.setAttribute("poster", "/image/thumb-video-ads.jpg");
      } else {
        this.$refs.video.setAttribute(
          "poster",
          "/image/thumb-video-ads-mobile.jpg"
        );
      }
    },

    playVideo() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.isDesktop) {
              entry.target.src = require("~/assets/video/video-aleo-ads.mp4");
            } else {
              entry.target.src = require("~/assets/video/video-aleo-ads-mobile.mp4");
            }
            entry.target.play();
            io.unobserve(entry.target);
          }
        });
      });

      io.observe(this.$refs.video);
    },

    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
